import { computed, inject, Injectable, signal } from "@angular/core";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { VerifyPayeeMode, VerifyPayeePayload, VerifyPayeeResponse } from "@models/verify-payee";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class VerifyPayeeService {
	private readonly apiService = inject(ApicallService);
	public verifyPayeeMode = signal<VerifyPayeeMode>(null);
	public verifyPayeeResponse = signal<VerifyPayeeResponse>(null);
	public showLoadingSpinner = signal<boolean>(false);
	public isVopFlagEnabled = signal<boolean>(false);
	public isBankTransfer = signal<boolean>(false);
	reqUrl = computed(() => `transactions/fiat/${this.verifyPayeeMode()}/verification`);

	public verifyPayee$(payload: VerifyPayeePayload): Observable<VerifyPayeeResponse> {
		const reqUrl = `transactions/fiat/${this.verifyPayeeMode()}/verification`;
		const option = new ApicallOption(null, payload);
		option.apiVersion = "v2";
		return this.apiService.post(reqUrl, option);
	}

	public updateAcceptanceStatus(): Observable<VerifyPayeeResponse> {
		const id = this.verifyPayeeResponse().id;
		const reqUrl = `transactions/fiat/verification/${id}`;
		const payload = {
			acceptance_status: "NOT_ACCEPTED"
		};
		const option = new ApicallOption(null, payload);
		option.apiVersion = "v2";
		return this.apiService.patch(reqUrl, option);
	}
}
